const SNAPSHOT_FIELDS = [
  "complaint",
  "branch_id",
  "original_disease",
  "content",
  "requiredTime",
];

/**
 * 文字列系の値を比較しやすい形に正規化する（null/undefined/空文字→null、それ以外→文字列）。
 */
const normalizeString = (value) => {
  if (value === null || value === undefined) {
    return null;
  }
  const stringValue = String(value);
  return stringValue === "" ? null : stringValue;
};

/**
 * 数値系の値を比較しやすい形に正規化する（null/undefined/空文字/NaN→null、それ以外→Number）。
 */
const normalizeNumber = (value) => {
  if (value === null || value === undefined || value === "") {
    return null;
  }
  const numberValue = Number(value);
  return Number.isNaN(numberValue) ? null : numberValue;
};

/**
 * 回答オブジェクトから、未保存変更の判定に使うスナップショットを作る。
 */
export const normalizeAnswerSnapshot = (answer) => {
  const safeAnswer = answer || {};
  return {
    complaint: normalizeString(safeAnswer.complaint),
    branch_id: normalizeNumber(safeAnswer.branch_id),
    original_disease: normalizeString(safeAnswer.original_disease),
    content: normalizeString(safeAnswer.content),
    requiredTime: normalizeString(safeAnswer.requiredTime),
  };
};

/**
 * 2つのスナップショットが完全一致するか（比較対象フィールドが全て一致するか）を判定する。
 */
export const isAnswerSnapshotEqual = (left, right) => {
  if (left == null && right == null) {
    return true;
  }
  if (left == null || right == null) {
    return false;
  }
  return SNAPSHOT_FIELDS.every((field) => left[field] === right[field]);
};

/**
 * 保存済みスナップショットと現在の回答を比較し、未保存の変更があるかを判定する。
 */
export const hasUnsavedChanges = (savedSnapshot, answer) => {
  if (!savedSnapshot) {
    return false;
  }
  const currentSnapshot = normalizeAnswerSnapshot(answer);
  return !isAnswerSnapshotEqual(savedSnapshot, currentSnapshot);
};
